import React from 'react';
import './feedbackestabelecimentos.scss';

// ícones PNG do canal (ajuste caminhos se necessário)
import gmbIcon from '../../comentnovo/listwithicon/iconimages/gmb.png';
import facebookIcon from '../../comentnovo/listwithicon/iconimages/facebook.png';
import instagramIcon from '../../comentnovo/listwithicon/iconimages/instagram.png';
import tiktokIcon from '../../comentnovo/listwithicon/iconimages/tiktok.png';
import tripadvisorIcon from '../../comentnovo/listwithicon/iconimages/tripadvisor.png';
import youtubeIcon from '../../comentnovo/listwithicon/iconimages/youtube.png';
import twitterIcon from '../../comentnovo/listwithicon/iconimages/twitter.png';
import amazonIcon from '../../comentnovo/listwithicon/iconimages/amazon.png';
import bookingIcon from '../../comentnovo/listwithicon/iconimages/booking.png';

const canalIcons = [
  { match: 'google', icon: gmbIcon },
  { match: 'gmb', icon: gmbIcon },
  { match: 'facebook', icon: facebookIcon },
  { match: 'instagram', icon: instagramIcon },
  { match: 'tiktok', icon: tiktokIcon },
  { match: 'tripadvisor', icon: tripadvisorIcon },
  { match: 'youtube', icon: youtubeIcon },
  { match: 'twitter', icon: twitterIcon },
  { match: 'amazon', icon: amazonIcon },
  { match: 'booking', icon: bookingIcon },
];

function IconCanal({ canal }) {
  if (!canal) return <span>—</span>;
  const key = canal.toLowerCase();
  const found = canalIcons.find(c => key.includes(c.match));
  return found ? <img src={found.icon} alt={canal} className="canal-ico" /> : <span>{canal}</span>;
}

export default function FeedbackEstabelecimentos({ title, escopo, items = [], nls = {}, componentNls = {}, autor, filtros = [], totaldata }) {
  
  console.log('🔍 componentNls recebido:', componentNls); // ← ADICIONE ESTA LINHA
  
  return (
    <>
    <section className="box-comentarios box-content-like">     
      
      {filtros.length > 0 && (
        <div className="feedback-filtros-aplicados">
          <p className="filtros-label">{nls?.filtrosAplicados || 'Filtros aplicados'}:</p>
          <ul className="filtros-lista">
            {filtros.map((filtro, idx) => (
              <li key={idx} className="filtro-item">
                <strong>{filtro.nomedofiltro}:</strong> {filtro.valordofiltro}
              </li>
            ))}
          </ul>
        </div>
      )}
            
      <div className="box-comentarios-tabela">
        <table className="tabela-comentarios">
          <thead>
            <tr>
              <th className="th-loja">{componentNls?.estabelecimento || 'Estabelecimento'}</th>
              <th className="th-comentario">{componentNls?.comentario || 'Comentário'}</th>
              <th className="th-canal">{componentNls?.canal || 'Canal'}</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan={3} className="fl-empty">
                  {componentNls?.semdadosparaexibir || 'Sem dados para exibir'}
                </td>
              </tr>
            ) : (
              items.map((r, i) => (
                <tr key={i} className="row-hoverable">
                  <td className="col-loja">{r.loja || '—'}</td>
                  <td className="col-comentario">{r.comentario}</td>
                  <td className="col-canal"><IconCanal canal={r.canal} /></td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </section>
    {totaldata !== null && totaldata !== undefined && (
      <div className="feedback-totaldata-outside">
        {nls?.numerodefeedbacks}: <strong>{totaldata}</strong>
      </div>
    )}
  </>
  );
}


/*
SEGUE O JSON DESSE TÓPICO:

{
      "nls": {
        "canal": "CHANNEL",
        "comentario": "FEEDBACK",
        "estabelecimento": "ESTABLISHMENT",
        "semdadosparaexibir": "No data"
      },
      "label": "Feedback por estabelecimento",
      "scope": {
        "periodo": {
          "fim": "2025-09-30",
          "ini": "2025-09-01"
        },
        "projetoId": 47
      },
      "params": {
        "RPP": 50,
        "tipo": "lojas",
        "idiomaId": 1,
        "empresaId": 236, //NÃO É OBRIGATÓRIO - BASTA OMITIR
        "pageNumber": 1,
        "categoriaId": 0  //NÃO É OBRIGATÓRIO - BASTA OMITIR
      },
      "Filtros": [
        {
          "nomedofiltro": "Empresa",
          "valordofiltro": "Todas"
        },
        {
          "nomedofiltro": "Categoria",
          "valordofiltro": "Todas"
        }
      ],
      "ordinal": 3,
      "topicKey": "feedbackestabelecimentos"
      
    }




*/

